import * as M from '@mui/material';
import { createTheme } from '@mui/material/styles';

import { lightTheme } from '../../themes';
import colors from '../../themes/colors';
import { placeholder } from '../../themes/pseudo';

export const TextError = M.styled(M.Typography)(({ theme, spacing }) => ({
  fontSize: '10px',
  padding: '5px 0 0',
  fontStyle: 'italic',
}));

export const mainTheme = createTheme({
  overrides: {
    MuiInputBase: {
      root: {
        borderRadius: '30px',
        border: `1px solid ${lightTheme.palette.primary.grayTwelfth}`,
        padding: '7px 15px',
      },
      input: {
        padding: '0px',
        height: 'auto',
        lineHeight: 1.3,
        ...placeholder({
          fontFamily: 'AvenirNext-Regular',
          fontSize: '12px',
          fontWeight: 500,
          color: lightTheme.palette.primary.grayTwelfth,
          opacity: 1,
        }),
      },
      inputMultiline: {
        ...placeholder({
          fontFamily: 'AvenirNext-Regular',
          fontSize: '10px',
          fontWeight: 500,
          color: lightTheme.palette.primary.grayTwelfth,
          opacity: 1,
        }),
      },
      colorSecondary: {
        backgroundColor: lightTheme.palette.primary.whiteTwo,
      },
    },
    MuiTypography: {
      root: {
        fontSize: '11px',
        color: colors.red,
      },
    },
  },
});
